module.exports = __webpack_public_path__ + "static/step-3-c34f5b809161ac3fdfb071ed20826c31.png";